// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"1b4274f6","299":"ac25a5e0","394":"ce9aa6ee","510":"656d0e6d","629":"ba59d314","695":"d52a496c"}[chunkId] + ".chunk.css";
};